import Layout from '@/components/layout'
import { SignIn } from '@clerk/clerk-react'
import { useEffect, useMemo, useState } from 'react'
import { useRouter } from '@/hooks/useRouter'

export default function Page() {
  const [hallId, setHallId] = useState('')
  const { queryParams } = useRouter()

  useEffect(() => {
    const tempHallId = localStorage.getItem('tempHallId')
    if (tempHallId) {
      setHallId(tempHallId)
      localStorage.removeItem('tempHallId')
    }
  }, [])

  const handleRedirect = useMemo(() => {
    if (hallId) return `/hall/${hallId}`
    else if (queryParams.redirect === 'create') return '/create-debate'
    else if (queryParams.redirect === 'pricing') return '/paddle-checkout'
  }, [queryParams, hallId])

  return (
    <Layout>
      <div className="flex justify-center items-center">
        <SignIn forceRedirectUrl={handleRedirect} />
      </div>
    </Layout>
  )
}
